import { FC } from 'react';

import { collectionTypeGuard, PageContentType } from '@models/Content';

import { ContentIcon, ContentIconProps } from './ContentIcon';

export type ColoredContentIconProps = Omit<ContentIconProps, 'contentType'> & {
  contentType: PageContentType;
};

export const ColoredContentIcon: FC<ColoredContentIconProps> = ({ contentType, ...rest }) => {
  const isCollection = collectionTypeGuard(contentType);
  const baseContentType = isCollection ? 'collection' : contentType;

  return (
    <ContentIcon
      contentType={contentType}
      sx={{
        color: theme => theme.palette.custom.content[baseContentType],
      }}
      {...rest}
    />
  );
};
